import customAxios from '../../../utils/customAxios';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarning,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';
import { Alert } from '@mui/material';

const ModalDInventoryType = ({ data, show, onHide, refreshData }) => {
  const {
    manufacturerModalDeleteString,
    manufacturerNameStr,
    manufacturerDescriptionStr,
    modalYesString,
    modalNoString,
  } = useTranslationHook();

  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const deleteRes = await customAxios.delete(
        `${GlobalVariables.getURL()}inventory/deleteInventoryType/${data.id}`,
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );

      getToast({
        status: 'success',
        title: 'Almacén eliminado correctamente',
      });
      setIsLoading(false);
      handleClose();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      getToast({ status: 'error', title: error.response.data.message });
    }
  };

  const handleClose = () => {
    refreshData();
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className='modal-title' id='contained-modal-title-vcenter'>
          ¿Quieres borrar este almacén?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Alert
            variant='standard'
            severity='warning'
            icon={false}
            style={{
              paddingLeft: '10px',
              textAlign: 'center',
              marginBottom: '10px',
            }}
          >
            Si haces esto, las <b>ubicaciones y refacciones</b> dentro de este
            almacén dejarán de visualizarse.
          </Alert>
          <span className='delete-info'>
            <strong>{manufacturerNameStr}:</strong> {data.name}
          </span>
          <span className='delete-info'>
            <strong>{manufacturerDescriptionStr}:</strong> {data.description}
          </span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className='modal-button'
          disabled={isLoading}
          onClick={handleDelete}
        >
          <FontAwesomeIcon icon={faWarning} /> {modalYesString}
        </button>
        <button className='modal-button no' onClick={handleClose}>
          <FontAwesomeIcon icon={faCircleChevronLeft} /> {modalNoString}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDInventoryType;
